module.exports = __webpack_public_path__ + "images/emoji/tada.fad142fc1e374313af21.png";